import styled, { css, keyframes } from 'styled-components';
import { white, highlightGray, gray } from 'styles/colors';
import { spacer8, spacer16, spacer24, spacer32 } from 'styles/spacers';
import Icon from 'components/atoms/icon/Icon';
import { fontWeights } from 'styles/variables';

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownInput = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${highlightGray};
  color: ${white};
  border: none;
  border-radius: 3rem;
  padding: ${spacer24} ${spacer32};
  cursor: pointer;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  gap: ${spacer8};
`;

export const DropdownText = styled.span`
  padding-right: 2.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: ${fontWeights.extra_bold};
  font-size: 1.25rem;
  line-height: 110%;
  letter-spacing: -1%;
`;

export const StyledCaret = styled(Icon)<{ open?: boolean }>`
  pointer-events: none;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : '')};
  transition: transform 0.3s;
  transform-origin: center 40%;
  height: 2.275rem;
  width: 2rem;
  color: ${white};
`;

export const DropdownList = styled.div<{ open: boolean }>`
  position: absolute;
  top: calc(100% + ${spacer8});
  left: 0;
  width: 100%;
  background: ${highlightGray};
  border-radius: 1rem;
  box-shadow: 0 4px 16px 1px rgba(0, 0, 0, 0.3);
  z-index: 10;
  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  transition: opacity 0.3s, visibility 0.3s;
  display: flex;
  flex-direction: column;
  animation: ${({ open }) =>
    open &&
    css`
      ${slideIn} 0.3s
    `};
`;

export const Option = styled.button<{ selected: boolean }>`
  width: 100%;
  background: none;
  border: none;
  color: ${white};
  padding: ${spacer16} ${spacer24};
  text-align: left;
  cursor: pointer;
  font-family: 'Spotify Mix Text', Helvetica, Arial, sans-serif;
  font-size: 20px;
  line-height: 110%;
  letter-spacing: -1%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: ${({ selected }) =>
    selected ? fontWeights.extra_bold : fontWeights.normal};
  &:hover,
  &:focus {
    background: ${highlightGray};
    outline: none;
  }
`;

export const SelectedValue = styled.span`
  flex: 1;
  font-size: 2rem;
  color: ${white};
`;

export const Label = styled.span`
  font-weight: ${fontWeights.normal};
  font-size: 2rem;
  line-height: 110%;
  letter-spacing: -1%;
  color: ${gray};
  margin-right: ${spacer8};
  flex-shrink: 0;
`;
